import { observer } from 'mobx-react-lite'
import { OCRConfirmArchiveDialog } from '@/features/jobs/scoping/components/OCRConfirmArchiveDialog'
import { type OCRConfirmArchiveDialogViewModel } from './OCRConfirmArchiveDialogViewModel'

export interface OCRConfirmArchiveDialogContainerProps {
  vm: OCRConfirmArchiveDialogViewModel
}

export const OCRConfirmArchiveDialogContainer = observer(
  function OCRConfirmArchiveDialogContainer({
    vm,
  }: OCRConfirmArchiveDialogContainerProps) {
    return (
      <OCRConfirmArchiveDialog
        showing={vm.modal.showing}
        onClose={vm.cancel}
        onConfirm={vm.archive}
      />
    )
  },
)
